"use client";
import Image from "@/components/Image";

const FunctionXy = () => {
  const items = [
    {
      title: "校本作业",
      desc: "教辅、练习册、试卷等纸质资源数字化。支持内容自动打标，涵盖：学科、题型、题目标签、难易度、题目所属知识点。",
    },
    { title: "校本卷库", desc: "学校专属试卷库，支持对接第三方教学资源。" },
    {
      title: "云端题库",
      desc: "海量题库、覆盖全学科、全学段（小学、初中）、多版本教材资源。老师可以在题库中选题组卷。",
    },
    {
      title: "我的题库",
      desc: "选题组卷或本地上传沉淀的个性化题库，可重复利用。",
    },
    {
      title: "蜜蜂智阅一体机",
      desc: "软硬件一体产品，支持发布自定义作业、数字化后的教辅、英语/语文作文等练习，智能批改、原卷打印批改痕迹、输出单次/阶段学情分析、打印错题练习等。",
    },
    {
      title: "AI作业批改",
      desc: "AI自动批改所有有唯一标准答案的题目（含纸质作业原卷处理）。",
    },
    {
      title: "智能作业管理",
      desc: "课本同步：听写、跟读背诵；课本打卡：跟读背诵打卡、听写打卡；口算批改等。",
    },
    {
      title: "AI作文批改",
      desc: "AI自动批改语文和英语作文，给予旁批点评、综合评价和全文润色。",
    },
    { title: "错题本", desc: "自动收录学生个人和班级错题，支持错题重练。" },
    {
      title: "学生学情",
      desc: "学生维度学期练习提交完成情况，排名得分趋势变化，以正确率标识知识点掌握情况，薄弱点一目了然。",
    },
    {
      title: "阶段学情",
      desc: "练习/考试维度，一段时间内成绩分析、知识点分析、错题分析，支持班级、年级、校级、区级纵横比。",
    },
    {
      title: "课堂模式",
      desc: "链接电子白板，方便课堂讲评。题目作答情况、错误率自动统计。作业原卷、逐题正确率、学生答题情况一屏展示。学生姓名可隐藏，支持全屏、缩小、放大、复原、拖动、画笔、擦除、撤销、重做、清空等互动工具",
    },
    { title: "数舱模式", desc: "校维度纵览学生学习过程中的作业情况。" },
  ];

  const bgColors = ["#FFFFFF", "#EDF3F7"];

  return (
    <section
      id="FunctionXy"
      className="flex w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] bg-[#EDF3F7] mx-auto"
    >
      {/* 主体部分 */}
      <div className="flex flex-col w-full max-w-[1360px] mx-auto gap-[60px] pt-[90px] pb-[120px]">
        {/* 上面部分 - 标题区域 */}
        <div className="flex flex-col w-full  mx-auto items-center justify-center gap-[20px]">
          {/* 标题文字 */}
          <h2 className="h-auto font-semibold text-[46px] leading-[52px] tracking-[0px] text-[#333333] text-center">
            蜜蜂家校亮点功能详解
          </h2>
          <div className="h-auto font-[400] text-[18px] leading-[28px] tracking-[2px] text-[#666666] text-center">
            聚焦AI批改作业管理闭环，助力 AI 精准教学、打造智慧校园
          </div>
        </div>
        {/* 中间部分 - 图片区域 */}
        <div className="flex mx-auto items-center justify-center">
          {/* 第一个按钮 - 绿色 */}

          <a
            href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-[174px] h-[56px] rounded-[30px] py-[14px] px-[30px] bg-[#1DBA55] text-white text-[18px] font-medium"
          >
            咨询价格
          </a>
        </div>
        {/* 下面部分 - 表格区域 */}
        <div className="flex flex-col w-full  mx-auto gap-[15px] bg-[#E3EDF3] rounded-[20px]  px-[32px] [@media(max-width:660px)]:px-[10px] pb-[32px] pt-[25px]">
          {/* 表头区域 */}
          <div className="flex flex-row">
            <div className="flex w-[237px] px-[24px] font-semibold text-lg leading-7 tracking-wider text-center text-[#333333]">
              功能名称
            </div>
            <div className="flex w-[237px] px-[24px] font-semibold text-lg leading-7 tracking-wider text-center text-[#333333]">
              功能介绍
            </div>
          </div>
          {/* 表格区域 */}
          <div className="flex flex-col w-full  mx-auto">
            {items.map((item, idx) => (
              <div className="flex flex-row w-full gap-[4px]" key={idx}>
                <div
                  className="flex px-[24px] py-[19px] gap-[6px] items-center"
                  style={{ background: bgColors[idx % 2], width: 237 }}
                >
                  <Image
                    src="/true_xy_02.png"
                    alt="advantage_xy_01"
                    className="object-contain w-[18px] h-[18px]"
                    width={18}
                    height={18}
                  />
                  <div className="flex w-[183px]  [@media(max-width:660px)]:w-full h-auto font-[400] text-[14px] leading-[16px] tracking-normal text-[#333333]">
                    {item.title}
                  </div>
                </div>
                <div
                  className="flex w-full h-auto px-[24px] py-[19px] items-center"
                  style={{ background: bgColors[idx % 2] }}
                >
                  <div className="flex h-auto font-[400] text-[14px] leading-[24px] tracking-normal text-[#333333]">
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunctionXy;
